export enum EnumDataType {
  number = 'int',
  string = 'text',
  boolean = 'boolean',
  image = 'image'
}
